import { useParams } from "react-router-dom";
import { useReduxDispatch, useReduxSelector } from "../redux/hooks";
import { useEffect, useRef, useState } from "react";
import { ticketConnect, ticketDisconnect } from "../redux/reducers/TicketViewSlice";
import { ChatApi } from "../redux/api/ChatApi";
import { IUser } from "../types/IUser";
import { Avatar } from "@progress/kendo-react-layout";
import './TicketView.scss';
import { Popover } from '@progress/kendo-react-tooltip';
import { Button } from '@progress/kendo-react-buttons';
import { SvgIcon } from '@progress/kendo-react-common';
import * as svg from '@progress/kendo-svg-icons';

type showProps = {
    show: boolean,
    anchor: any
    user: IUser
}
const TicketView = () => {
    const dispatch = useReduxDispatch();
    const { ticketId } = useParams();
    const { data: profile } = ChatApi.useGetProfileQuery();
    const { data: currentUser } = ChatApi.useGetUserQuery(profile?.Uid, { skip: !profile?.Uid });
    const usersOnline = useReduxSelector(s => s.ticketViewSlice?.activeUsers);
    let thisTicketUsers = usersOnline?.[ticketId]?.users?.filter((u: IUser) => u.UId !== profile?.Uid) || [];

    const anchor = useRef(null);
    const [show, setShow] = useState<showProps>({} as showProps);

    useEffect(() => {
        if (profile && currentUser) {
            dispatch(ticketConnect({ tenantId: profile.Tenant_Uid, ticketId: parseInt(ticketId), user: currentUser }));

            return () => {
                dispatch(ticketDisconnect({ tenantId: profile.Tenant_Uid, ticketId: parseInt(ticketId), user: currentUser }));
            };
        }
    }, [dispatch, ticketId, profile, currentUser]);

    if (!thisTicketUsers.length || !profile?.Features.WhoIsViewingTicket) return null;

    return (
        <div className="live-ticket-view" style={{ backgroundColor: profile?.Nav_Hex_Color, color: '#fff' }}>
            <label>Currently viewing this {profile?.Phrases.CallPhrase}:</label>
            {thisTicketUsers?.map((user: IUser, index) => (
                <div key={index} className="user-online" ref={anchor} title={user.FullName}>
                    <Button className="m-1" fillMode="flat" onClick={(e) => setShow(s => {
                        return { ...s, show: !s.show, anchor: e.currentTarget, user: user }
                    })
                    } >
                        {profile?.Features.Profile_Images && user.Profile_Image_Path
                            ? <Avatar type='image' size='medium' >
                                <img className='profile-image2'
                                    alt={`Profile image for ${user.FullName}`}
                                    src={user.Profile_Image_Path ? user.Profile_Image_Path : './images/placeholder.png'}
                                />
                            </Avatar>
                            : <Avatar type='text' size='medium' >
                                {user.F_Name?.charAt(0).toUpperCase() + user.L_Name?.charAt(0).toUpperCase()}

                            </Avatar>
                        }
                    </Button>
                </div >))}
            {show?.user &&
                <Popover callout={true} popoverClass={"live-ticket-view-tooltip-callout"}
                    show={show?.show}
                    anchor={show?.anchor || anchor.current}
                    position={"left"} positionMode="fixed" offset={{ top: 50, left: 0 }} >
                    <div className="live-ticket-view-tooltip">
                        <div className="d-flex justify-content-center">
                            {profile?.Features.Profile_Images && show?.user.Profile_Image_Path
                                ? <Avatar type='image' size='medium' >
                                    <img className='profile-image2'
                                        alt={`Profile image for ${show?.user.FullName}`}
                                        src={show?.user.Profile_Image_Path ? show?.user.Profile_Image_Path : './images/placeholder.png'}
                                    />
                                </Avatar>
                                : <Avatar type='text' size='medium' >
                                    {show?.user.F_Name?.charAt(0).toUpperCase() + show?.user.L_Name?.charAt(0).toUpperCase()}

                                </Avatar>
                            }
                        </div>
                        <h5>{show.user.FullName} {show.user.Team_Name ? <>({show.user.Team_Name})</> : ''}</h5>
                        <h6>{show.user.Company_Name}</h6>
                        <div><SvgIcon icon={svg.envelopIcon} />  {show.user.PrimaryEmail}</div>
                        {/* <div>{show.user.Bus_Phone && <SvgIcon icon={svg.phon} />  {show.user.Bus_Phone}}</div> */}
                    </div>
                </Popover>}
        </div >
    );
};

export default TicketView;
